import { useEffect } from 'react';

export const useScript = (text, condition = true) => {
    useEffect(() => {
        if (!condition) return;

        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.text = text;

        document.body.appendChild(script);

        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            } else {
                console.warn('Script was already removed or not found in document.body:', script);
            }
        };
    }, [text, condition]);
};